if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && event.target.closest('deferred-media.media-type-video')) {
            this.hide();
          }
        });
      }

      hide() {
        super.hide();
        requestAnimationFrame(() => {
          document.querySelectorAll('media-gallery deferred-media.media-type-video').forEach((deferredMedia) => {
            const video = deferredMedia.querySelector('video');
            if (video) {
              video.play();
            } else {
              deferredMedia.loadContent(false);
            }
          });
        });
      }

      show(opener) {
        super.show(opener);
        this.querySelectorAll('deferred-media.media-type-video').forEach((deferredMedia) => {
          deferredMedia.loadContent(false);
        });
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'center' });

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.offsetWidth !== undefined) {
          const scrollLeft = activeMedia.offsetLeft - (container.clientWidth - activeMedia.offsetWidth) / 2;
          container.scrollLeft = Math.max(0, Math.min(scrollLeft, container.scrollWidth - container.clientWidth));
        }
      }
    }
  );
}
